export enum SurveyQuestionTypeEnumes {
  NUMBER = 'Number',
  STRING = 'String',
  SCALE = 'Scale',
  TIME = 'Time',
  OPTIONS = 'Options',
  NUMBER_RANGE = 'Number-Range',
  DATE_RANGE = 'Date-Range',
  TIME_RANGE = 'Time-Range',
  MULTIPLE_OPTIONS = 'Multiple-Option',
  INFO = 'Info',
}

export enum SurveyQuestionTypeEnum {
  NUMBER = 'number',
  STRING = 'string',
  SCALE = 'scale',
  TIME = 'time',
  OPTIONS = 'options',
  NUMBER_RANGE = 'number-range',
  DATE_RANGE = 'date-range',
  TIME_RANGE = 'time-range',
  MULTIPLE_OPTIONS = 'multiple-option',
}
